import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/ECE301end21.pdf'
import csm from '../assets/ECE301mid21.pdf'


export default function Ed() {
  return (
    <div>
       <Subject title="Electronic Devices(ECE301)"mid="Q. Paper"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}